import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
    import("@lexus.com/ui/dist/modules/LargeFeature")
);

const ComponentEditConfig = {
  emptyLabel: "Large Feature",
  isEmpty: function (props) {
      return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  const {subHeading, componentDesign, mediaOpacity, ...rest} = props || {};
  const {contentWidth, marginLeft, marginRight, paddingRight, paddingLeft} = componentDesign || {};

  return {
    ...rest,
    contentWidth,
    marginLeft,
    marginRight,
    paddingLeft,
    paddingRight,
    boxOpacity: mediaOpacity,
    subheading: subHeading,
}};

const LargeFeature = (props) => {
  const data = transformData(props);
  return <Component {...data} />
};

export default withAemIntegration("lexus/components/content/large-feature")(
    LargeFeature,
    ComponentEditConfig
);
